import { GNS } from '../core/GNS.js';

/**
 * GNS.AbstractElementView
 * 
 * すべてのView要素の基底クラス
 * 
 * 責務:
 * - show/hide の基本動作（CSSクラスの付け外し）
 * - 状態管理 (isShow)
 */
GNS.AbstractElementView = function (GNS) {
    const View = GNS.create(GNS.DisplayObject);

    View.init = function (elementId) {
        View._super.init.apply(this, [elementId]);
        this.isShow = false;
    };

    View.show = function () {
        this.isShow = true;
        this.addClass("show");
    };

    View.hide = function () {
        this.isShow = false;
        this.removeClass("show");
    };

    return View._self;
}(GNS);
